<template>
  <div>
    <vs-row>
        <!-- <pre>{{courseLists}}</pre> -->
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-w="12"
      >
        <vx-card title="Select View" class="mb-4">

<!-- Subject Component -->
          <vs-row>
              <subject-listing fromModule="topic" @SearchCourseEvent="seachOvaralll" @filterSubjectEvent="filterBySubject" ></subject-listing>
              <!-- <h3 class="pl-2 mt-4">Courses</h3>
              <vs-divider></vs-divider>
              <div class="scrollable-container">
              <vs-button class="w-full text-left pl-2"
                :key="index.id"
                v-for="(item, index) in courses"
                type="flat"
              >{{item.text}}</vs-button>
              </div> -->
              <vs-col vs-lg="2" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="flex-end" class="p-1">
                <vs-button type="filled" @click="$router.push({name: 'course-builder',params: { type: 'topics' }}).catch(() => {})" v-if="checkCreatePermission()"
              >Create</vs-button>
              </vs-col>
          </vs-row>
<!-- Subject Component -->


        </vx-card>
      </vs-col>
<!-- <pre>{{topicLists}}</pre> -->
      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="flex-start"
        vs-w="12"
      >
        <vs-card class="cstm_vx_card mb-4">
          <div slot="header">
            <div class="flex flex-wrap items-center">
              <div class="p-1 xl:w-11/12 w-full">
                <v-select
                  class="w-full"
                  label="name"
                  placeholder="Enter tags to search"
                  :reduce="(option) => option.id"
                  :options="tagModuleWise"
                  v-model="tagSearch"
                  :clearable="false"
                  data-vv-name="tag_list"
                  name="tag_list"
                  multiple
                ></v-select>
              </div>

                <!-- {{tagSearch}} -->
              <div class="p-1 xl:w-1/12 w-full text-left xl:text-right">
                <vs-button class="w-full" @click="tagSearchWise">Search</vs-button>
              </div>
            </div>
          </div>
          <div>
            <div class="text-right" v-if="selectedLength && checkDeletePermission()">
              <div class="bulk_holder">
                <a @click="bulkDelete">
                  Bulk Delete
                </a>
              </div>
            </div>
            <!-- <vs-button
              v-if="selectedLength && checkDeletePermission()"
              icon-pack="feather"
              style="float: right"
              color="danger"
              icon="icon-trash-2"
              @click="bulkDelete"
              >Bulk Delete</vs-button
            > -->
  <!-- <pre>{{lessonLists}}</pre> -->

         <!-- <pre>{{topicLists}}</pre>    -->
            <vs-table
              class="cstm_vuexy_table"
              multiple
              v-model="selected"
              :data="topicLists"
            >

              <template slot="header">
                <!-- <pre>{{courseLists}}</pre> -->
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Description </vs-th>
                <vs-th> Subject </vs-th>
                <vs-th style="min-width: 115px;"> No. of Files </vs-th>
                <vs-th> Tags </vs-th>
                <vs-th style="width: 80px;"> Active </vs-th>
                <vs-th v-if="checkEditPermission() || checkDeletePermission()" style="width: 80px;"> Action </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td >
                    {{ data[indextr].name }}
                  </vs-td>
                    <vs-td >
                    {{ data[indextr].description }}
                  </vs-td>

                  <vs-td>
                   <!-- <pre> {{data[indextr] }}</pre> -->
                    <div v-if="data[indextr].has_all_subject">General</div>
                    <div v-else>
                      <span v-for="(subject,index) in data[indextr].subjects" :key="index">
                        <span> {{subject.subject_name}}</span>
                      <span v-if="index+1 < data[indextr].subjects.length">, </span>
                    </span>
                    </div>
                  </vs-td >
                        <vs-td >
                    {{data[indextr].topicFiles.length}}
                  </vs-td>

                  <vs-td>
                      <span v-for="(tag,tagindex) in data[indextr].topicTags" :key="tagindex">
                                {{tag.tag.name}}
                      <span v-if="tagindex+1 < data[indextr].topicTags.length">, </span>
                    </span>
                   </vs-td>

                   <vs-td>
                    <div class="switch-container mr-2">
                      <div class="center con-switch">
                        <vs-switch
                        class="vs-switch-success"
                        @click="ChangeStatus(data[indextr].status, data[indextr].id, indextr, 'Topic')"
                        v-model="data[indextr].status"

                        />
                      </div>
                    </div>
                  </vs-td>

                  <vs-td v-if="checkEditPermission() || checkDeletePermission()">
                    <vs-dropdown
                      vs-custom-content
                      vs-trigger-click
                    >
                      <vs-button
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-more-vertical"
                      ></vs-button>

                      <vs-dropdown-menu style="min-width: 100px">
                        <vs-dropdown-item @click="openEditView(data[indextr])">Edit</vs-dropdown-item>
                        <vs-dropdown-item @click="openConfirm(data[indextr].id, data[indextr],'single', 'topic')">Delete</vs-dropdown-item>
                        <!-- <vs-dropdown-item @click="ChangeStatus(data[indextr].status, data[indextr].id, indextr, 'Topic')">{{ data[indextr].status ? 'Deactivate' : 'Activate' }}</vs-dropdown-item> -->
                      </vs-dropdown-menu>
                    </vs-dropdown>
                    <!-- <vs-button
                      icon-pack="feather"

                      icon="icon-edit"
                      @click="openEditView(data[indextr])"
                    ></vs-button> -->
                  </vs-td>

                  <!-- <vs-td v-if="checkDeletePermission()">
                    <vs-button
                      icon-pack="feather"

                      color="danger"
                      icon="icon-trash-2"
                      @click="openConfirm(data[indextr].id, data[indextr],'single', 'topic')"

                    ></vs-button>
                  </vs-td> -->
                </vs-tr>
              </template>
            </vs-table>
            <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
              <ItemsPerTableDropdown
                tableName="topic_list"
                @change="(pageLimit) => (pageLimitSet = pageLimit)"
              />
            </vs-col>
            <pagination
              :meta="meta"
              @page-change="handlePageChange"
              class="ml-auto"
            />
            </vs-row>
          </div>

        </vs-card>
      </vs-col>
    </vs-row>
    <!-- {{get_homework_subject_id}}
    {{statusstatus}} -->
    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <h3>One or more topics could not be deleted as they are referred somewhere else.</h3>
      <vs-list>
        <vs-list-item v-for="(item, index) in nonDeletableItems" :key="index" :title="item"></vs-list-item>
      </vs-list>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { topicListing} from '@/api/course-builderapi'
import subjectListing from '@/views/pages/v1/lesson/subjectListing.vue'
import {mapGetters, mapActions} from 'vuex'
import {DeleteMixin} from '../mixins/DeletingMixins'
import { Tag } from '@/mixins/tag/tag'

import {StatusMixin} from '../mixins/StatusMixin'

import {PaginationData} from '@/mixins/pagination'

import Pagination from '@/components/common/pagination'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'


export default {
  components: {
    vSelect,
    subjectListing,
    Pagination
  },
  mixins:[DeleteMixin, StatusMixin, Tag, PaginationData, PermissionMiddleware],
  computed:{
    ...mapGetters(
      ['get_homework_subject_id']
    ),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  created () {
    //this.checkingQuery('/pages/topiclist')
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Course')
    }

  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  mounted () {
    // this.fetchTopicList()
    this.SET_HOMEWORK_SUBJECT_ID(null)
    this.fetchTag(this.platform_module_id)

  },
  methods:{
    seachOvaralll (search) {
      this.search = search
      this.fetchTopicList()
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    filterBySubject (subject_ids) {

      this.tagSearch = []
      if (subject_ids == 0) {
        this.subject_ids = false

      } else {
        this.subject_ids = subject_ids

      }
      this.fetchTopicList()

    },
    tagSearchWise () {
      this.subject_ids = false
      this.fetchTopicList()

    },
    ...mapActions(
      ['SET_HOMEWORK_SUBJECT_ID']
    ),
    async fetchTopicList () {
      try {
        this.$vs.loading({
          text:'Fetching Topics please wait ...'
        })
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids:[this.subject_ids],
            is_visible: true
          }


        } else {
          payload = {
            tag_ids:this.tagSearch,
            is_visible: true
          }

        }
        const customer_id = this.$store.getters.customerId
        /* const queryParams = this.$route.query || {}
        this.query_page.page = queryParams.page || 1 */
        payload.search = this.search
        payload.limit = this.pageLimitSet
        const responseList = await topicListing(customer_id, payload, this.meta.current_page)

        this.topicLists =  responseList.data.data.topiclist
        this.meta = responseList.data.data.meta


      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }

    },
    //redirecting for editing
    openEditView (editingObject) {

      this.$router.push({
        name: 'topicDetails',
        params: { editing_object: editingObject,
          editing_type:'topics',
          section:'topics'
        }
      })

    },
    handlePageChange (page) {
      //
      //const queryPayload = Object.assign({}, this.$route.query)
      this.meta.current_page = page || this.meta.current_page + 1
      /* queryPayload.page = page
      // queryPayload.limit = 10
      const pageScroll = document.documentElement.scrollTop
      this.$router.replace({ path: '/pages/topiclist', query: queryPayload  }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.fetch_list(queryPayload)
      this.fetchTopicList()
    }

  },
  data () {
    return {
      search:'',
      subject_ids:false,
      platform_module_id:3,
      listingtype:'topic',
      pageLimitSet:5,
      //courseLists:[],
      //lessonLists:[],
      tagSearch: [],
      topicLists:[],
      selected: [],
      courses: [
        {
          id: '1',
          size: '1.34KB',
          image: 'download.png',
          text: 'Instrumental Pro',
          file: 'Piano Course',
          count: '10'
        },
        {
          id: '2',
          size: '1.34KB',
          image: 'download.png',
          text: 'Trial Lesson',
          file: 'Synthesizer Course',
          count: '16'
        },
        {
          id: '3',
          size: '1.34KB',
          image: 'download.png',
          text: 'Little Genius',
          file: 'Guitar Course',
          count: '4'
        }
      ]
    }
  }

}
</script>
